import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { saveAs } from 'file-saver';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';

@Component({
  selector: 'app-eligible-employees-popup',
  templateUrl: './eligible-employees-popup.component.html',
  styleUrls: ['./eligible-employees-popup.component.scss'],
})
export class EligibleEmployeesPopupComponent  implements OnInit {

  marketCorrectionEmployeesData:any[] = []
  getIncrementFyYearList:any[] = [];
  loggedInUserCompanyID:any
  loggedInCompanyFiscalyear:any
  fromYear:any;
  toYear:any;
  isToggleChecked:any = false;
  countMaleDaysServedTotal:any;
  countFeMaleDaysServedTotal:any;
  loggedInUserRole:any;
  isShowExcelData:any = false;
  eligibleMaleRowData: any[] = [];
  eligibleFeMaleRowData: any[] = [];
  pinnedBottomRowDataMale: any[] = [];
  pinnedBottomRowDataFeMale: any[] = [];


  constructor(private httpService: HttpService, private config: Config,
  private encryptionService: EncryptionService, public dialog: MatDialog, private datePipe: DatePipe, private loader: LoaderService,
  ){}

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.getIncrementFYyear();
  }

  getIncrementFYyear(){
    const request =  {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }    
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result:any)=>{             
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          } 
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;    

      this.getEligibleMaleEmployee();
      this.getEligibleFeMaleEmployee();
    })
  }
  getEligibleMaleEmployeeData:any = [];
  getEligibleFeMaleEmployeeData:any = [];

  maleTotalCount:any
  FeMaleTotalCount:any

  getEligibleMaleEmployee(){
    let request = {}
    if(this.loggedInUserRole == 'HOD'){
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": false,
        "eligibleMaleEmps": true,
        "fromYear": this.fromYear,
        "isHod": true,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }else{
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": false,
        "eligibleMaleEmps": true,
        "fromYear": this.fromYear,
        "isHod": false,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }
    this.httpService.callPostService(this.config.getDashboardLists, request).subscribe((result:any)=>{
      this.getEligibleMaleEmployeeData = result.data;
      this.calculateEligibleMaleEmployeeData(result.data)
      this.maleTotalCount = this.getEligibleMaleEmployeeData.reduce((total: number, department: any) => {
        return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employeeData.length;
        }, 0);
      }, 0);
      this.buildMaleGridData();
    })
  }

  getEligibleFeMaleEmployee(){
    let request = {}
    if(this.loggedInUserRole == 'HOD'){
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": true,
        "eligibleMaleEmps": false,
        "fromYear": this.fromYear,
        "isHod": true,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }else{
      request = {
        "companyId": this.loggedInUserCompanyID,
        "eligibleFemaleEmps": true,
        "eligibleMaleEmps": false,
        "fromYear": this.fromYear,
        "isHod": false,
        "marketCorrectionEmps": false,
        "promotionGivenEmp": false,
        "toYear": this.toYear
      }
    }
    this.httpService.callPostService(this.config.getDashboardLists, request).subscribe((result:any)=>{
      this.getEligibleFeMaleEmployeeData = result.data;
      this.calculateEligibleFeMaleEmployeeData(result.data)
      this.FeMaleTotalCount = this.getEligibleFeMaleEmployeeData.reduce((total: number, department: any) => {
        return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employeeData.length;
        }, 0);
      }, 0);
      this.buildFeMaleGridData();
    })
  }

  getTotalRowSpan(bandGrades: any[]): number {
    let totalRows = 0;
    bandGrades.forEach(bandGrade => {
      totalRows += bandGrade.employeeData.length;
    });
    return totalRows;
  }

  calculateEligibleMaleEmployeeData(data: any[]){
    this.countMaleDaysServedTotal = 0;
    let totalDaysServedCount = 0

  data.forEach(department => {
        department.bandGrades.forEach((bandGrade: any) => {
          bandGrade.employeeData.forEach((employee: any) => {
            // this.countMaleDaysServedTotal += parseFloat(employee.daysServed || 0);
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.countMaleDaysServedTotal += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }            
          });
        });
      });
      if (totalDaysServedCount > 0) {
        this.countMaleDaysServedTotal = parseFloat((this.countMaleDaysServedTotal / totalDaysServedCount).toFixed(2));
      }
  }

  calculateEligibleFeMaleEmployeeData(data: any[]){
    this.countFeMaleDaysServedTotal = 0;
    let totalFemaleDaysServedCount = 0
  data.forEach(department => {
        department.bandGrades.forEach((bandGrade: any) => {
          bandGrade.employeeData.forEach((employee: any) => {
            // this.countFeMaleDaysServedTotal += parseFloat(employee.daysServed || 0);
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.countFeMaleDaysServedTotal += parseFloat(employee.daysServed);
              totalFemaleDaysServedCount++;
            }    
          });
        });       
      });
      if (totalFemaleDaysServedCount > 0) {
        this.countFeMaleDaysServedTotal = parseFloat((this.countFeMaleDaysServedTotal / totalFemaleDaysServedCount).toFixed(2));
      }  
  }


  exportToExcel() {
    this.loader.simpleLoader();
    this.isShowExcelData = true;
    const tableName = this.isToggleChecked ? 'feMaleData' : 'maleData';
  
    if(tableName == 'feMaleData'){
          setTimeout(() => {
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
            const flattenedData: any[] = [];
            const formatDate = (date: string) => {
              const formattedDate = new Date(date);
              return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
            };
            const currentYear = new Date().getFullYear();
            const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
            this.getEligibleFeMaleEmployeeData.forEach((department: any) => {
              department.bandGrades.forEach((band: any) => {
                band.employeeData.forEach((employee: any) => {
                  flattenedData.push({
                    "Department": department.departmentName,
                    "Band": band.band,
                    "Employee": employee.employeeName,
                    "Manager": employee.managerName,
                    "HOD": employee.hodName,
                    "DOJ": formatDate(employee.dateOfJoining),
                    "Eligible emp": employee.isEligible ? "Yes" : "No",
                    "Days served in the increment period": `${employee.daysServed || 0}`,
                  });
                });
              });
            });
            flattenedData.push({
              "Department": 'Total',
              "Band": '',
              "Employee": '',
              "Manager": '',
              "HOD": '',
              "DOJ": '',
              "Eligible emp": '',
              "Days served in the increment period": `${this.countFeMaleDaysServedTotal || 0}`,
            });
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
            const defaultCellStyle = {
              alignment: { horizontal: "left", vertical: "top" },
              font: { name: "Arial", sz: 12 }
            };
            const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
            for (let row = range.s.r; row <= range.e.r; row++) {
              for (let col = range.s.c; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
                if (worksheet[cellAddress]) {
                  worksheet[cellAddress].s = defaultCellStyle;
                }
              }
            }
            worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
            const workbook: XLSX.WorkBook = {
              Sheets: { 'data': worksheet },
              SheetNames: ['data'],
            };
            const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
            const fileName = `Eligible_Employee_Female_Data_${formattedDate}`;
            saveAs(data, fileName);
            this.isShowExcelData = false;
            this.loader.dismissLoader();
          }, 1000);
    }else if(tableName == 'maleData'){
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getEligibleMaleEmployeeData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "DOJ": formatDate(employee.dateOfJoining),
                "Eligible emp": employee.isEligible ? "Yes" : "No",
                "Days served in the increment period": `${employee.daysServed || 0}`,
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "DOJ": '',
          "Eligible emp": '',
          "Days served in the increment period": `${this.countMaleDaysServedTotal || 0}`,
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Eligible_Employee_Male_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }
  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }


  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object 
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }

  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;
  searchTaskString: string = '';

  resetGrid() {
    this.isClicked = false; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  eligibleColumnDefs: ColDef[] = [
    {
      headerName: 'Department',
      field: 'departmentName',
    },
    {
      headerName: 'Band',
      field: 'band',
    },
    {
      headerName: 'Employee',
      field: 'employeeName',
    },
    {
      headerName: 'Manager',
      field: 'managerName',
    },
    {
      headerName: 'HOD',
      field: 'hodName',
    },
    {
      headerName: 'DOJ',
      field: 'dateOfJoining',
      valueFormatter: (params) => {
        if (!params.value) return '';
        const d = new Date(params.value);
        return isNaN(d.getTime()) ? params.value : d.toLocaleDateString('en-GB');
      }
    },
    {
      headerName: 'Eligible emp',
      field: 'isEligible',
      valueFormatter: (params) => params.value ? 'Yes' : 'No'
    },
    {
      headerName: 'Days served in the increment period',
      field: 'daysServed',
      valueFormatter: (params) =>
        params.value != null ? Number(params.value).toLocaleString('en-IN') : ''
    }
  ];
  
  eligibleDefaultColDef: ColDef = {
    resizable: true,
    sortable: true,
    filter: true,
  };
  // 🔹 Build AG Grid data for Male
buildMaleGridData() {
  this.eligibleMaleRowData = [];

  this.getEligibleMaleEmployeeData.forEach((department: any) => {
    department.bandGrades.forEach((band: any) => {
      band.employeeData.forEach((employee: any) => {
        this.eligibleMaleRowData.push({
          departmentName: department.departmentName,
          band: band.band,
          employeeName: employee.employeeName,
          managerName: employee.managerName,
          hodName: employee.hodName,
          dateOfJoining: employee.dateOfJoining,
          isEligible: employee.isEligible,
          daysServed: employee.daysServed,
        });
      });
    });
  });

  this.pinnedBottomRowDataMale = [
    {
      departmentName: 'Total',
      band: '',
      employeeName: '',
      managerName: '',
      hodName: '',
      dateOfJoining: '',
      isEligible: '',
      daysServed: this.countMaleDaysServedTotal || 0,
    }
  ];
}

// 🔹 Build AG Grid data for Female
buildFeMaleGridData() {
  this.eligibleFeMaleRowData = [];

  this.getEligibleFeMaleEmployeeData.forEach((department: any) => {
    department.bandGrades.forEach((band: any) => {
      band.employeeData.forEach((employee: any) => {
        this.eligibleFeMaleRowData.push({
          departmentName: department.departmentName,
          band: band.band,
          employeeName: employee.employeeName,
          managerName: employee.managerName,
          hodName: employee.hodName,
          dateOfJoining: employee.dateOfJoining,
          isEligible: employee.isEligible,
          daysServed: employee.daysServed,
        });
      });
    });
  });

  this.pinnedBottomRowDataFeMale = [
    {
      departmentName: 'Total',
      band: '',
      employeeName: '',
      managerName: '',
      hodName: '',
      dateOfJoining: '',
      isEligible: '',
      daysServed: this.countFeMaleDaysServedTotal || 0,
    }
  ];
}

  // --------------------------------AG GRID CODE---------------------------------------------------------
}
